import { registerSW } from "virtual:pwa-register";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ProvedorApp } from "./estado.tsx";
import { router } from "./router.tsx";
import { aplicarTema, temaAtual } from "./tema.ts";
import "./app.css";
import "./cartoes.css";

// O index.html já pôs o tema escolhido no <html>; aqui a barra do sistema acompanha.
aplicarTema(temaAtual());

// App shell offline; a versão nova entra na próxima abertura.
if (import.meta.env.PROD) registerSW({ immediate: true });

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ProvedorApp>
      <RouterProvider router={router} />
    </ProvedorApp>
  </StrictMode>,
);
